import { PricingPlan } from "@/primary-models";

export const FRESH_PRICING_PLAN_DETAILS: Record<PricingPlan, {
  quantity: number;
  cadence: number;
}> = {
  [PricingPlan.TRIAL]: {
    quantity: 14,
    cadence: 14,
  },
  [PricingPlan.FREEZER]: {
    quantity: 14,
    cadence: 14,
  },
  [PricingPlan.STANDARD]: {
    quantity: 28,
    cadence: 28,
  },
  [PricingPlan.HALF]: {
    quantity: 28,
    cadence: 56,
  },
  [PricingPlan.SAVER]: {
    quantity: 42,
    cadence: 42,
  },
  [PricingPlan.TRIAL_WEEK]: {
    quantity: 7,
    cadence: 10,
  },
};
